import { DropdownMenu } from '@buffer-mono/popcorn'

import { useBulkActionsMenuContext } from './BulkActionsMenuContext'

import type { JSX } from 'react'

// Mentions counterpart to ResolveCommentsItem. Mirrors the menu structure so the
// UI is consistent across tabs.
export function ResolveMentionsItem(): JSX.Element {
  const { requestResolve } = useBulkActionsMenuContext()

  return (
    <DropdownMenu.Group label="Mentions">
      <DropdownMenu.Item
        onSelect={(): void => {
          requestResolve('all')
        }}
      >
        Resolve All Mentions
      </DropdownMenu.Item>
      <DropdownMenu.Item
        onSelect={(): void => {
          requestResolve('older-than-month')
        }}
      >
        Resolve Older Mentions
      </DropdownMenu.Item>
    </DropdownMenu.Group>
  )
}
